import { useExamContext } from "@features/exam/contexts/ExamContext";
import { getShowStudyPackViews } from "@helpers/exams";
import { useAppStore } from "@hooks/useAppStore";
import { isWeb } from "@memorang/helpers/platform";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { type DrawerNavResult, buildDrawerNavItems } from "./helpers";

export type {
	BuildParams,
	DrawerNavResult,
	NavigationRoute,
} from "./helpers";

export const useDrawerNavItems = (): DrawerNavResult => {
	const navigationRoutes = useAppStore((s) => s.navigation?.routes.main);
	const hideStudyPack = useAppStore((s) => s.navigation?.hideStudyPack);
	const showStudyPackAsHome = useAppStore((s) => s.showStudyPackAsHome);
	const store = useAppStore((s) => s.store);
	const showRedeem = useAppStore((s) => s.homeView?.showRedeem);
	const practiceTestLabel = useAppStore((s) => s.exam.practiceTest?.label);
	const practiceTestEnabled = useAppStore((s) => s.exam.practiceTest?.enabled);

	const {
		currentExamContext: { studyPackCollectionId, practiceTestProductNumericId },
	} = useExamContext();

	const { t } = useTranslation();

	const showStudyPackViews =
		!hideStudyPack && getShowStudyPackViews(studyPackCollectionId);

	return useMemo(
		() =>
			buildDrawerNavItems({
				navigationRoutes: navigationRoutes ?? [],
				showStudyPackAsHome: !!showStudyPackAsHome,
				studyPackCollectionId,
				showStudyPackViews,
				practiceTestProductNumericId,
				practiceTestEnabled,
				practiceTestLabel,
				storeEnabled: store.enabled,
				showRedeem,
				t,
				isWebPlatform: isWeb,
			}),
		[
			navigationRoutes,
			showStudyPackAsHome,
			studyPackCollectionId,
			showStudyPackViews,
			practiceTestProductNumericId,
			practiceTestEnabled,
			practiceTestLabel,
			store.enabled,
			showRedeem,
			t,
		],
	);
};
